import ApiServiceAPI from './api/api.service';

export default class FileUploader {
  BUCKET_NAME = 'chrncl-asset';

  async sendToS3(file: File, s3FileName: string): Promise<void> {
    await new ApiServiceAPI().put(s3FileName, file);
  }
}
